import { t } from "../i18n";

/**
 * The buttons under a template or an interactive message, as WhatsApp draws them: an icon per
 * kind, and with more than three, the first two and "See all options".
 */
export const buttonIcon = (type: string): string =>
  (
    ({
      url: "external",
      phone: "phone",
      phone_number: "phone",
      list: "options",
      options: "options",
      copy_code: "copy",
    }) as Record<string, string>
  )[type.toLowerCase()] ?? "reply";

export function shownButtons(
  buttons: Array<{ type: string; text: string }> | undefined,
): Array<{ type: string; text: string }> {
  const all = (buttons ?? []).filter((b) => b.text.trim());
  return all.length > 3
    ? [
        ...all.slice(0, 2),
        { type: "options", text: t("templates.all_options") },
      ]
    : all;
}
